import React from 'react';
import { pains } from '../data/pains';
export function PainSection() {
  return <section className="border-y border-ink-line bg-ink-panel px-4 py-8" data-id="element-116" data-mp="38xwtwht0vg3k">
      <div className="mx-auto max-w-4xl" data-id="element-117" data-mp="38vu7s8uzq744">
        <h2 className="text-center text-xl font-extrabold sm:text-3xl" data-id="element-118" data-mp="2uyovhr4ooc0f">
          Does This Sound Familiar?
        </h2>
        <div className="mx-auto mt-3 max-w-2xl space-y-1.5 text-center text-sm leading-snug text-ink-text sm:text-base" data-id="element-119" data-mp="2yypgjumaflgg">
          <p data-id="element-120" data-mp="2l718c2f5th4r">
            You love helping children and adults improve their communication skills and reach
            meaningful therapy goals...
          </p>
          <p data-id="element-121" data-mp="2baxx872by85o">But preparing every therapy session is becoming another full-time job.</p>
          <p data-id="element-122" data-mp="2g8py3qkyd4m0">
            If you're a Speech Therapist working in private practice, schools, clinics,
            rehabilitation centers, hospitals, or early intervention programs...
          </p>
          <p data-id="element-123" data-mp="2792vx2kefurw">You've probably experienced at least one of these situations.</p>
        </div>

        <div className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-124" data-mp="3rmr3nw73il0y">
          {pains.map(pain => <article key={pain.title} className="rounded-xl border border-ink-line bg-ink-bg p-4" data-id="element-125" data-mp="3rovfd0b8kobs">
              <h3 className="text-sm font-bold sm:text-lg" data-id="element-126" data-mp="3nnrzidt6usak">{pain.title}</h3>
              <p className="mt-1 text-xs font-semibold text-gold sm:text-sm" data-id="element-127" data-mp="5f192h7xl06i">{pain.lead}</p>
              <ul className="mt-1.5 space-y-0.5 text-xs leading-snug text-ink-text sm:text-sm" data-id="element-128" data-mp="h970udknxol">
                {pain.items.map(item => <li key={item} data-id="element-129" data-mp="38ugh5cwr0zp0">{item}</li>)}
              </ul>
              <p className="mt-1.5 text-xs font-semibold leading-snug text-white sm:text-sm" data-id="element-130" data-mp="33yhohd4e0vis">
                {pain.close}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}